import api, { handleApiResponse } from './client';

export const getMenus = async (menuId = 1) => {
    return handleApiResponse(api.get(`/menus/${menuId}?locale=en`));
};

// Returns the flat items array from the root menu node (ready for Header transformation)
export const getMenuItems = async (menuId = 1, locale = 'en') => {
  try {
    const res = await api.get(`/menus/${menuId}?locale=${locale}`);
    const root = res.data?.data?.[0] || res.data?.[0];
    return root?.items || [];
  } catch (err) {
    console.error('Menu API error:', err);
    return [];
  }
};
